import AresLogo from "../../../../src/images/services/ares-gateway.svg";
import * as React from 'react';
export default {
  AresLogo,
  React
};